export interface MapCoordinate {
  lat?: number | string | null;
  lng?: number | string | null;
}

const normalizeText = (value?: string | null) => value?.trim() || "";
const normalizeAbsoluteHttpUrl = (value?: string | null) => {
  const normalized = normalizeText(value);
  if (!normalized) {
    return null;
  }

  try {
    const parsed = new URL(normalized);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return parsed.toString();
    }
  } catch (_error) {
    return null;
  }

  return null;
};

const toFiniteNumber = (value: number | string | null | undefined) => {
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export function getKakaoMapUrl(
  siteName?: string | null,
  coordinate?: MapCoordinate | null,
) {
  const normalizedSiteName = normalizeText(siteName);
  const lat = toFiniteNumber(coordinate?.lat);
  const lng = toFiniteNumber(coordinate?.lng);

  if (!normalizedSiteName || lat === null || lng === null) {
    return null;
  }

  return `https://map.kakao.com/link/map/${encodeURIComponent(normalizedSiteName)},${lat},${lng}`;
}

export function getNaverMapUrl(address?: string | null) {
  const normalizedAddress = normalizeText(address);

  if (!normalizedAddress) {
    return null;
  }

  return `https://map.naver.com/v5/search/${encodeURIComponent(normalizedAddress)}`;
}

export function getTmapUrl(
  siteName?: string | null,
  coordinate?: MapCoordinate | null,
) {
  const normalizedSiteName = normalizeText(siteName);
  const lat = toFiniteNumber(coordinate?.lat);
  const lng = toFiniteNumber(coordinate?.lng);

  if (!normalizedSiteName || lat === null || lng === null) {
    return null;
  }

  return `https://www.tmap.co.kr/tmap2/mobile/route.jsp?goalname=${encodeURIComponent(normalizedSiteName)}&goalx=${lng}&goaly=${lat}`;
}

export function resolvePreferredMapUrl(
  directUrl?: string | null,
  fallbackUrl?: string | null,
) {
  return normalizeAbsoluteHttpUrl(directUrl) || normalizeText(fallbackUrl) || null;
}
